export type FolderModel = {
  id: string;
  parentId?: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  authorId: string;
  taskId?: string;
  thumbnailUrl?: string;
  /** The project's Auto publish (klap-api src/services/auto_publish_service.ts). Read-only here. */
  autoPublish?: { enabled: boolean; accountIds: string[] };
};

export const FOLDER_ID_LENGTH = 8;

export const deserializeFolder = (dbFolder: any): FolderModel => {
  return {
    id: dbFolder.id,
    parentId: dbFolder.parent_id,
    createdAt: new Date(dbFolder.created_at),
    updatedAt: new Date(dbFolder.updated_at),
    name: dbFolder.name,
    authorId: dbFolder.author_id,
    taskId: dbFolder.task_id,
    thumbnailUrl: dbFolder.thumbnail_url,
    autoPublish: dbFolder.auto_publish ? {
      enabled: dbFolder.auto_publish.enabled === true,
      accountIds: Array.isArray(dbFolder.auto_publish.account_ids)
        ? dbFolder.auto_publish.account_ids.filter((id: unknown): id is string => typeof id === "string")
        : [],
    } : undefined,
  };
};

export const serializeFolder = (folder: FolderModel): any => {
  return {
    id: folder.id,
    parent_id: folder.parentId,
    created_at: folder.createdAt,
    updated_at: folder.updatedAt,
    name: folder.name,
    author_id: folder.authorId,
    task_id: folder.taskId,
    thumbnail_url: folder.thumbnailUrl,
  };
};
